module.exports = __webpack_public_path__ + "img/portrait-ears-mask.39e050bb.svg";